import React from 'react';
import { GlowButton } from './ui/GlowButton';
interface CTASectionProps {
  onCtaClick?: () => void;
}
export function CTASection({
  onCtaClick
}: CTASectionProps) {
  return <section className="py-12 md:py-20 px-4 relative overflow-hidden" data-id="element-79">
      {/* Background Gradient Line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent opacity-50" data-id="element-80" />

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-81">
        <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold tracking-[-0.03em] mb-1 md:mb-2 text-white" data-id="element-82">
          Ready to Launch Your
        </h2>
        <h2 className="text-xl md:text-2xl lg:text-3xl font-extrabold tracking-[-0.03em] mb-4 md:mb-6" data-id="element-83">
          <span className="text-gradient" data-id="element-84">Faceless Channel?</span>
        </h2>
        <p className="text-xs md:text-sm text-gray-400 mb-6 md:mb-8 max-w-md mx-auto leading-relaxed tracking-[0.01em]" data-id="element-85">
          Join the creators already earning from YouTube without ever being on
          camera.
        </p>

        <div className="flex flex-col items-center gap-3 md:gap-4" data-id="element-86">
          <GlowButton className="w-full sm:w-auto" onClick={onCtaClick} data-id="element-87">
            Start My Faceless Channel
          </GlowButton>

          <p className="label-caps text-[9px] md:text-[10px] text-gray-500 max-w-sm mx-auto tracking-[0.12em]" data-id="element-88">
            Limited spots each month. We work closely with every creator we
            onboard.
          </p>
        </div>
      </div>

      {/* Bottom Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-blue-600/10 rounded-full blur-[100px] pointer-events-none" data-id="element-89" />
    </section>;
}